import { render, staticRenderFns } from "./PatientTransferFormFromBrandToDenzapine.vue?vue&type=template&id=0959f2ee"
import script from "./PatientTransferFormFromBrandToDenzapine.vue?vue&type=script&lang=js"
export * from "./PatientTransferFormFromBrandToDenzapine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports